module.exports = __webpack_public_path__ + "static/media/currency-custom-text.878879a6.png";